var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_712_3415)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_712_3415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.875 2.68752V18.3125H23.4375C23.869 18.3125 24.2188 18.6623 24.2188 19.0938V20.6562C24.2188 21.0877 23.869 21.4375 23.4375 21.4375H15.625C15.1935 21.4375 14.8438 21.0877 14.8438 20.6562V19.0938C14.8438 18.6623 15.1935 18.3125 15.625 18.3125H17.1875V12.0625H7.8125V18.3125H9.37498C9.80647 18.3125 10.1562 18.6623 10.1562 19.0938V20.6562C10.1562 21.0877 9.80647 21.4375 9.37498 21.4375H1.56252C1.13103 21.4375 0.78125 21.0877 0.78125 20.6563V19.0938C0.78125 18.6623 1.13103 18.3125 1.56252 18.3125H3.125V2.68752H1.56252C1.13103 2.68752 0.78125 2.33773 0.78125 1.9063V0.343766C0.78125 -0.0877188 1.13103 -0.4375 1.56252 -0.4375H9.37503C9.80652 -0.4375 10.1563 -0.0877188 10.1563 0.343766V1.90625C10.1563 2.33773 9.80652 2.68752 9.37503 2.68752H7.8125V8.9375H17.1875V2.68752H15.625C15.1935 2.68752 14.8438 2.33773 14.8438 1.90625V0.343766C14.8438 -0.0877188 15.1935 -0.4375 15.625 -0.4375H23.4375C23.869 -0.4375 24.2188 -0.0877188 24.2188 0.343766V1.90625C24.2188 2.33773 23.869 2.68752 23.4375 2.68752H21.875Z",
    fill: "#99439D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_712_3415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_712_3415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 -1.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/Header.8a0e858112d6163e609373c56c0af71e.svg";
export { ForwardRef as ReactComponent };